/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    IOLinesMode,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Tibbits from '@appblocks/codegeneration/Tibbits';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';

export const getCodeBlocks = (feature: BaseTibbit): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    const currentSocket = Number(feature.getSettingValue('SOCKET'));
    const prevSocket = (currentSocket - 1).toString();
    const PRESSURE_NAME = feature.getSettingValue('PRESSURE_NAME');
    const { project } = feature;
    const ID = feature.getID();
    const connectedSocket = (Number(feature.getSettingValue('SOCKET')) - 1).toString();

    blocks.push({
        location: `var_${PRESSURE_NAME}_update`,
        blockType: BlockType.CODE,
        template: `
var_${PRESSURE_NAME}_update_completed(simulator.context['${ID}']['PRESSURE_NAME'])`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
this.updateContext('${ID}', {
    'PRESSURE_NAME': ${PRESSURE_NAME}
});
        `,
    });

    return blocks;
};
